/** The "Adjust" section label with its "Clear all (n)" action. */
export function PhotoEffectsAdjustBar({
  activeCount,
  onClearAll,
}: {
  activeCount: number
  onClearAll: () => void
}) {
  return (
    <div className="flex h-7 w-full flex-row items-center">
      <div className="flex min-w-0 flex-1 items-start rounded-sm px-2 py-1.5">
        <span className="text-xs font-bold leading-4 text-[#737373]">Adjust</span>
      </div>
      <button
        type="button"
        className="h-4 shrink-0 text-xs font-medium leading-4 text-[#737373] underline"
        aria-label={`Clear all (${activeCount})`}
        data-photo-effects-clear-all
        onClick={onClearAll}
      >
        {`Clear all (${activeCount})`}
      </button>
    </div>
  )
}
